import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, isRef as _isRef, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/close100.png'


const _withScopeId = n => (_pushScopeId("data-v-c403da84"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "trash flex-ter" }
const _hoisted_2 = { class: "goods-title" }
const _hoisted_3 = {
  key: 0,
  class: ""
}
const _hoisted_4 = {
  key: 0,
  style: {"height":"48px","padding":"0 20px","justify-content":"space-between","color":"#D4B106","font-weight":"500"},
  class: "flex-ter cart-bar"
}
const _hoisted_5 = { style: {"line-height":"20px"} }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { style: {"color":"#000000A6","font-weight":"700"} }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "body" }

import { t } from '@/plugins/i18n'
import { useStore } from 'vuex'
import { ref, computed, reactive, watch } from 'vue'
import CheckBox from './CheckBox.vue'
import ShopItem from './ShopItem.vue'
import additional from './additional.vue'
import { deleteSku } from '@/apis/shopcart'
import { confirmClearCart } from '@/util/useConfirm'
import { isD2C, useRtfix, isJA } from '@/store'
import QuestionMark from '@/components/IconPark/QuestionMark.vue'
import ChangeAdt from './ChangeAdt.vue'
import Empty from './Empty.vue'

export default /*#__PURE__*/_defineComponent({
  props: [
  'list',
  'listCheckMap',
  'layout',
  'cartIdList',
  'mode',
  'refKey',
  'goodsType',
  // 选择choice商品后普通商品禁止选中
  'choiceDisabled',
  'checkList',
  'showChoice',
  'isJpTitkTokShop'
],
  emits: ['update', 'calc', 'change'],
  setup(__props, { emit }) {

const props = __props
const shopTableDeliverHasTip = ref(localStorage.shopTableDeliverHasTip)
watch(shopTableDeliverHasTip, () => {
  localStorage.shopTableDeliverHasTip = 'has'
})



// const listCheckMap = ref(props.listCheckMap)
const listCheckMap: any = ref([])
watch(() => props.listCheckMap, (newValue) => {
  listCheckMap.value = newValue
}, {
  deep: true,
  immediate: true
})
// 全选按钮点击固定取反，不判断当前状态
let checkAllValue = true
const checkAll = computed({
  get: () => {
    const arr = Object.values(listCheckMap.value)
    return arr.length && arr.every((v) => v)
  },
  set: (val) => {
    checkAllValue = !checkAllValue
    Object.keys(listCheckMap.value).forEach((k) => (listCheckMap.value[k] = checkAllValue))
  }
})

const isIndeterminate = computed(
  () => !checkAll.value && Object.values(listCheckMap.value).some((v) => v)
)

const updateList = ({ type, val }: any) => {
  if (type === 'delete') {
    delete listCheckMap.value[val.cartId]
    emit('update')
  } else if (type === 'check') {
    val[0].forEach((id: number) => {
      listCheckMap.value[id] = val[1]
    })
  } else if (!type) {
    emit('update')
  }
}

const handleClear = () => {
  const cartIdList = props.cartIdList
  if (!cartIdList.length) return
  confirmClearCart(
    () => {
      deleteSku({ cartIdList }).then(() => {
        emit('update')
        cartIdList.forEach((k: number) => {
          delete listCheckMap.value[k]
        })
      })
    },
    () => { }
  )
}


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: "table normal-goods-table",
    ref: (_value, _refs) => {
      _refs['goodsTableRef'] = _value
    }
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(__props.showChoice ? _unref(t)('代采商品') : ''), 1),
      _createElementVNode("div", {
        class: "del-btn",
        onClick: handleClear
      }, _toDisplayString(_unref(t)('一键删除')), 1),
      (!__props.isJpTitkTokShop)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(ChangeAdt, {
              list: __props.checkList,
              onUpdate: _cache[0] || (_cache[0] = ($event: any) => (emit('update'))),
              key: __props.refKey
            }, null, 8, ["list"])
          ]))
        : _createCommentVNode("", true)
    ]),
    (__props.mode && !shopTableDeliverHasTip.value && _unref(isD2C)())
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(t)('当前订单包含需采购的商品，如遇到商品无法采购等情况导致取消时，将通过异常联络通知您，您可在中更改默认项').split('\n'), (v) => {
              return (_openBlock(), _createElementBlock("span", { key: v }, _toDisplayString(v), 1))
            }), 128)),
            _createVNode(_component_router_link, {
              to: _unref(useRtfix)('setupShop', { query: { type: 'ShopGroup' } }),
              style: {"color":"var(--blcolor)","margin-left":"10px"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", {
                  innerHTML: _unref(t)('店铺配置->发货设置')
                }, null, 8, _hoisted_6)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createElementVNode("img", {
            style: {"height":"16px","cursor":"pointer"},
            src: _imports_0,
            alt: "",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (shopTableDeliverHasTip.value = true))
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "head flex-ter",
      style: _normalizeStyle({ top: __props.showChoice ? '168px' : '116px' })
    }, [
      _createVNode(CheckBox, {
        class: "select-all-class",
        modelValue: _unref(checkAll),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(checkAll) ? (checkAll).value = $event : null)),
        indeterminate: _unref(isIndeterminate),
        disabled: __props.choiceDisabled
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(t)('全选')), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "indeterminate", "disabled"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.layout, (v) => {
        return (_openBlock(), _createElementBlock("div", {
          key: v.label,
          class: _normalizeClass({ 'fx-1': v.width === 'auto' }),
          style: _normalizeStyle([{ width: (v.headerWidth || v.width) + 'px' }, {"font-weight":"700","color":"#000000A6"}])
        }, [
          _createTextVNode(_toDisplayString(typeof v?.fix === 'function' ? v?.fix(v.label) : v.label) + " ", 1),
          (v.name === 'customSku')
            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 0,
                effect: "light",
                placement: "top",
                "popper-class": "tool-tip-no-border"
              }, {
                content: _withCtx(() => [
                  _createElementVNode("div", {
                    style: _normalizeStyle({ maxWidth: _unref(isJA)() ? '520px' : '300px' })
                  }, [
                    _createElementVNode("div", {
                      innerHTML: _unref(t)('商品SKU作用旨在区分相同商品的不同规格、尺寸、颜色等。')
                    }, null, 8, _hoisted_8),
                    _createElementVNode("div", {
                      innerHTML: _unref(t)('您可以直接填写自家店铺现有的的商品SKU，也可以额外设置新的SKU。')
                    }, null, 8, _hoisted_9)
                  ], 4)
                ]),
                default: _withCtx(() => [
                  _createVNode(QuestionMark, {
                    size: 14,
                    color: "#000000A6"
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], 6))
      }), 128))
    ], 4),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(additional),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (v) => {
        return (_openBlock(), _createBlock(ShopItem, {
          key: v.cartGroupNo,
          layout: __props.layout,
          data: v,
          mode: __props.mode,
          list: __props.list,
          checkMap: listCheckMap.value,
          onUpdate: updateList,
          onCalc: _cache[3] || (_cache[3] = (e) => emit('calc', e)),
          choiceDisabled: __props.choiceDisabled
        }, null, 8, ["layout", "data", "mode", "list", "checkMap", "choiceDisabled"]))
      }), 128)),
      (__props.list.length === 0)
        ? (_openBlock(), _createBlock(Empty, { key: 0 }))
        : _createCommentVNode("", true)
    ])
  ], 512))
}
}

})